const sanitize = (part) => part ? part.replace(/^null$/, '') : part

export const formatAddress = (address, isBill) => {
  const name = sanitize(address?.[isBill ? 'billToName' : 'shipToName']) || '';
  const name2 = sanitize(address?.shipToName2) || '';
  const id = sanitize(address?.[isBill ? 'billToId' : 'shipToId']) || '';

  const line1 = `${name}${name2 && `, ${  name2}`}${name && id ? ' - ' : ''}${id}`;

  const address1 = sanitize(address?.address1) || '';
  const address2 = sanitize(address?.address2) || '';
  const city = sanitize(address?.city) || '';

  const line2 = `${address1}${address1 && address2 && ' '}${address2}${(address1 || address2) && city ? ', ' : ''}${city}`;

  const zip = sanitize(address?.zip) || '';
  const province = sanitize(address?.province) || '';
  const countryCode = sanitize(address?.country?.code) || '';

  const line3 = `${zip}${zip && province ? ', ' : ''}${province}${(zip || province) && countryCode ? ', ' : ''}${countryCode}`;

  return { line1, line2, line3, isBlocked: address?.isBlocked }
}
